import { Component } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { AutoContrasteService } from 'src/app/shared/directive/autocontraste.directive';
import { environment } from 'src/environments/environment';
import { HeaderService } from 'src/app/services/header.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  production = environment.production;
  ambiente = environment.ambiente;
  descricaoConcurso : string = '';
  descricaoPrazoConcurso : string ='';
  descricaoAmbienteApi : string='';
  ind_PrazoConcurso :  string ='';

  constructor(
              private titleService: Title,
              public autoContrasteService: AutoContrasteService,
              public objServiceApi : HeaderService,
              protected utilService: UtilService
  ) {}

  ngOnInit(): void {
    var title = "SCPEWEB - versão: " + environment.versao;

    if (environment.ambiente.length > 0)
      title ="SCPEWEB - versão: " + environment.versao + " - " + environment.ambiente;

    this.titleService.setTitle(title);

    this.utilService.showLoading(true);
    this.getAmbiente();
    this.carregarDescricaoConcurso();
    this.carregarPrazoConcurso();
    this.utilService.showLoading(false);
  }

 /*  btnOk() {
    window.location.href="https://www.site.emerj.jus.br";
  }
 */

  carregarDescricaoConcurso(){

    this.objServiceApi.getDescricaoConcurso().subscribe(retorno => {
          this.descricaoConcurso=retorno;
        },
        error=> {
          window.alert(error);
        }
      );
  }

  carregarPrazoConcurso(){

    this.objServiceApi.getPrazoConcurso().subscribe(retorno => {
          this.ind_PrazoConcurso = retorno.situacao;
          switch(this.ind_PrazoConcurso){
            case 'LIBERAR_COTISTA':
              this.descricaoPrazoConcurso='Período de inscrição válido para cotista';
              break;
/*             case 'NAO INICIADA':
              this.descricaoPrazoConcurso='Período de inscrição ainda não foi iniciado, ao clicar em OK você será redirecionado para página da EMERJ.';
              break;
            case 'ENCERRADA':
              this.descricaoPrazoConcurso='Período de inscrição encerrado, ao clicar em OK você será redirecionado para página da EMERJ.';
              break;
            case 'NAO_LIBERA':
                this.descricaoPrazoConcurso='Período de inscrição não liberado, ao clicar em OK você será redirecionado para página da EMERJ.';
                break; */
            default:
              this.descricaoPrazoConcurso='';
          }
        },
        error=> {
          window.alert(error);
        }
      );
  }

  getAmbiente(){

    this.objServiceApi.getAmbiente().subscribe(retorno => {
      var r = retorno.ambiente;
      // if(r === 'P' || r === 'AP' || r === ''){
      //   this.descricaoAmbienteApi='PRODUCAO';
      // }else if(r != 'P' && r != 'AP' && r != ''){
      //   this.descricaoAmbienteApi='Você está em Homologação.';
      // }else{
      //   //this.descricaoAmbienteApi='Ambiente da API não definido.';
      // }
      this.descricaoAmbienteApi=r;
    },
    error=> {
      window.alert(error);
    }
  );
  }

}
